<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div
          class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-primary-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10 sm:tw--mt-1.5"
        >
          <key-icon class="tw-h-6 tw-w-6 tw-text-primary-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left">
          <h3 class="tw-text-xl tw-font-thin">Confirm Send Password Reset Email</h3>
          <div class="tw-mt-2 tw-font-thin tw-text-gray-600">
            <p>Are you sure you want reset this user's password? They will be sent a new password and their old password will no longer be valid.</p>
          </div>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="sendEmail" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Confirm</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import { KeyIcon } from "@/assets/svgs";

export default {
  components: {
    KeyIcon,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async sendEmail() {
      try {
        this.isLoading = true;
        await this.$axios.post(`/businesses/${this.businessId}/users/${this.userId}/send-forgot-password-email`);
        this.EventBus.$emit("GLOBAL_NOTIFY", {
          title: "Email sent successfully",
          message: "The email to reset the user's password reset successfully",
        });
        this.hide();
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Error sending password reset email",
          message: "We were not able to send the password reset email. Please reload the page to try again.",
          error,
        });
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
